(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name trainingAuditReport.controller:TrainingAuditReportCtrl
   *
   * @description
   *
   */
  angular
    .module('trainingAuditReport')
    .controller('TrainingAuditReportCtrl', TrainingAuditReportCtrl);

  function TrainingAuditReportCtrl(TrainingProgramsService,crewScheduleService,CommonMasterData, $sce, CommonLogicService,
		  MessageService) {
    var vm = this;
    vm.ctrlName = 'TrainingAuditReportCtrl';

    vm.model = {
      searchOnGoing: false,
      searchPanelToggle: true,
      initialSearchDone: false,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        trainingCategory: null,
        crew: null
      },
      masterList: {
        trainingCategory: [],
        viewBy : [],
        crewTypes : [],
        crewDetails : [],
        fromDateAfterToDate : false,
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false
      },
      reportServerBaseUrl : null,
      reportDataURL : null

    };

    vm.clickOnSearch = function (){
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    vm.changeEditorField = function(searchParams,flag){
      switch (flag) {
        case "fromDate" :
          var tempFromDate = moment(searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
          if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
            searchParams.toDate = tempFromDate;
          }
          validateDateFields();
          break;
        case "toDate" :
          validateDateFields();
          break;
        case "crewType":
          loadCrewList(searchParams.crewType);
          break;
        default:
          break;
      }
    };

    function validateDateFields(){
      setDateValidationFlags();
      if(!!vm.model.searchCriteria.fromDate && !!vm.model.searchCriteria.toDate
        && !vm.model.masterList.fromDateFormatInvalid  && !vm.model.masterList.toDateFormatInvalid){
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        }else{
          vm.model.masterList.fromDateAfterToDate = false;
        }
      }
    };

    function setDateValidationFlags(){
      if(isDateFormatInvalid(vm.model.searchCriteria.fromDate)){
        vm.model.masterList.fromDateFormatInvalid = true;
        vm.model.masterList.fromDateAfterToDate = false;
      }else{
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      if(isDateFormatInvalid(vm.model.searchCriteria.toDate)){
        vm.model.masterList.toDateFormatInvalid = true;
        vm.model.masterList.fromDateAfterToDate = false;
      }else{
        vm.model.masterList.toDateFormatInvalid = false;
      }
    };

    function isDateFormatInvalid(date){
      if(!!date && !moment(date, "DD/MM/YYYY").isValid()){
        return true;
      }
      return false;
    };

    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };
    
    
	function loadCrewList(crewType) {
		var param = {};
		param.crewType = '';
		param.active = true;
		if (!!crewType) {
			param.crewType = crewType.crewTypeCode;
			CommonMasterData.loadCrewList(param, function(response) {
				vm.model.masterList.crewDetails = crewScheduleService
						.adaptCrewList(response);
			}, function() {
				console.log('Crew list retrieval error');
			});
		} else {
			vm.model.masterList.crewDetails = [];
		}
	};
	
	vm.searchByOptions = function (param){
		searchAuditReport(param);
	}
	
	function  searchAuditReport(param){
		vm.model.initialSearchDone = true;
		vm.model.searchPanelToggle = false;
		var rptDesign = "training_audit_report.rptdesign";
		var url = CommonLogicService.getReportUrl(rptDesign, getSearchParamMap(param));
		vm.model.reportDataURL = $sce.trustAsResourceUrl(url); 
	}
	

	function getSearchParamMap(param) {
	   var searchParamMap = {};
	   
	   searchParamMap["fromDate"] = param.fromDate;
	   searchParamMap["toDate"] = param.toDate;
	   searchParamMap["viewBy"] = param.viewBy.typeDesc;
	   
	   if(param.viewBy.typeDesc === 'Crew Member' && !nullOrEmpty(param.crewType)){
		   searchParamMap["crewType"] = param.crewType.crewTypeCode;
		   searchParamMap["crewTypeDesc"]= param.crewType.crewTypeDescription;
	   }
	   
	   if(param.viewBy.typeDesc === 'Crew Member' && !nullOrEmpty(param.crew)){
		   searchParamMap["crewName"] = param.crew.displayName;
		   searchParamMap["crewProfileId"] = param.crew.crewProfileId;
		   searchParamMap["crewId"] = param.crew.crewId;
	   }
	   
	   if(param.viewBy.typeDesc === 'Training Program' && !nullOrEmpty(param.trainingCategory)){
		   searchParamMap["category"] = param.trainingCategory.categoryCode.replace(" ","");
	   }
	   return searchParamMap;
	}
	
	function nullOrEmpty(value){
		if(value === null || value == ""||angular.isUndefined(value)|| value == " "){
			return true;
		}
	}

      TrainingProgramsService.getTrainingCategories(function(response){
        response.forEach(function (category) {
          if(category.showInTrainingAutomation === 'Y'){
            vm.model.masterList.trainingCategory.push(category);
          }
        });
      },function(error){});
      
      CommonMasterData.getTrainingAuditViewByTypes(
              function (viewByList) {
                  vm.model.masterList.viewBy = viewByList;
              },
        function () {
           console.log('Training Audit error');
        }
     );
      
    CommonMasterData.getCrewTypeList(function(crewTypes) {
			vm.model.masterList.crewTypes = crewTypes;
		}, function() {
			console.log('Crew types retrieval error');
	});
      
  }
}());
